import { useState } from 'react'

import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import { useDeleteCourt } from '@/hooks/useDeleteCourt'
import { ApiError, toApiError } from '@/lib/api/errors'
import type { CourtItem } from '@/lib/venue/courtTypes'

const WARNING_TEXT =
  '코트를 삭제하면 해당 코트의 운영시간 설정도 함께 삭제되고 이후 예약을 받을 수 없습니다. 삭제 후 복구할 수 없습니다.'

/** 삭제 확인 모달(요구사항 3). 409(예약 충돌)면 모달 안에서 서버 메시지로 대체 표시한다. */
export function CourtDeleteConfirmModal({
  venueId,
  court,
  onClose,
}: {
  venueId: string
  court: CourtItem
  onClose: () => void
}) {
  const [error, setError] = useState<ApiError | null>(null)
  const deleteMutation = useDeleteCourt(venueId)

  async function handleConfirm() {
    setError(null)
    try {
      await deleteMutation.mutateAsync(court.courtId)
      onClose()
    } catch (thrown) {
      setError(toApiError(thrown))
    }
  }

  return (
    <Modal title="코트 삭제" onClose={onClose}>
      <div className="space-y-4">
        <p className="text-sm text-slateish-600">
          <span className="font-medium text-ink-700">{court.name}</span>을(를) 삭제할까요?
        </p>

        {error ? (
          <Alert tone="danger">
            <p>{error.message}</p>
          </Alert>
        ) : (
          <Alert tone="warning">{WARNING_TEXT}</Alert>
        )}

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            취소
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="border-danger-500 text-danger-500 hover:bg-danger-100"
            disabled={deleteMutation.isPending}
            onClick={() => {
              void handleConfirm()
            }}
          >
            {deleteMutation.isPending ? '삭제하는 중…' : '삭제'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
